/**
 * Supabase Configuration Constants
 * Single source of truth for Supabase URL and API key
 * Used by both the client and system health checks
 *
 * Reads from import.meta.env with hardcoded fallbacks so that:
 * - Local dev works without .env
 * - CI can override via build-time env vars
 */

const PRODUCTION_SUPABASE_URL = "https://api.nokosha.olombelona.com";
const PREVIEW_SUPABASE_URL = "https://api-staging.nokosha.olombelona.com";
const PRODUCTION_SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzcyMzkzNTQ4LCJleHAiOjIwODc3NTM1NDh9.DSOUr8G2RNDQMMoCHpKDnUmYXqTkXwZKlKuDjkp1_cI";

const configuredAppMode = import.meta.env.VITE_APP_MODE?.trim();
const configuredSupabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const configuredSupabasePublishableKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();

export const APP_MODE = configuredAppMode === "preview" ? "preview" : "default";

if (APP_MODE === "preview") {
  if (!configuredSupabaseUrl || !configuredSupabasePublishableKey) {
    throw new Error(
      "Preview builds require explicit staging Supabase configuration.",
    );
  }

  if (configuredSupabaseUrl === PRODUCTION_SUPABASE_URL) {
    throw new Error(
      "Preview builds must not target the production Supabase backend.",
    );
  }

  if (configuredSupabaseUrl !== PREVIEW_SUPABASE_URL) {
    throw new Error(
      "Preview builds must use the app-centric staging Supabase backend.",
    );
  }
}

export const SUPABASE_URL = configuredSupabaseUrl || PRODUCTION_SUPABASE_URL;
export const SUPABASE_PUBLISHABLE_KEY =
  configuredSupabasePublishableKey || PRODUCTION_SUPABASE_PUBLISHABLE_KEY;
